import { Injectable } from '@angular/core';
import { IEnvironment } from '../../environments/ienvironment';
import { environment } from '../../environments/environment';

/**
 * Service that provides the environment.
 */
@Injectable({
  providedIn: 'root',
})
export class EnvironmentService implements IEnvironment {
  /** Returns true if app is in prod mode. */
  get production() {
    return environment.production;
  }

  /** The log level. */
  get logLevel() {
    return environment.logLevel;
  }

  /** The api url of the tool service. */
  get toolServiceUrl() {
    return environment.toolServiceUrl;
  }

  /** The api url of the tool service. */
  get chatServiceUrl() {
    return environment.chatServiceUrl;
  }

  /**
   * Creates an absolute asset url.
   *
   * @param fileName The name of the file
   * @returns The absolute url.
   */
  getFullAssetUrl(fileName: string): string {
    return `${this.toolServiceUrl}/assets${fileName}`;
  }
}
